import { render, staticRenderFns } from "./PubForm.vue?vue&type=template&id=ff4c2882&scoped=true&"
import script from "./PubForm.vue?vue&type=script&lang=js&"
export * from "./PubForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4c2882",
  null
  
)

export default component.exports